function formatNumber({
  value,
  locale,
  maximumFractionDigits = 2,
  minimumFractionDigits = 2,
}: {
  value: number | string | undefined | null;
  locale: string;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
}) {
  if (!value && value !== 0) {
    return value;
  }

  if (typeof value === 'number') {
    value = value.toString();
  }

  if (value.includes('.')) {
    value = value.slice(0, value.indexOf('.') + maximumFractionDigits + 1);
  }

  return new Intl.NumberFormat(locale === 'fr' ? 'fr' : 'en', {
    maximumFractionDigits,
    minimumFractionDigits,
    // @ts-expect-error
  }).format(value);
}

export default formatNumber;
